// extracted by mini-css-extract-plugin
export default {"section2":"section2_section2__VB3Hc","content_box1":"section2_content_box1__C75Eo","title1":"section2_title1__ovEiY","hero_title1":"section2_hero_title1__mEFpA"};